import { BASE_URL, URLS, setUrl, isDevEnv } from "utils/baseUrlProvider";
import { FormControl, MenuItem, Select } from "@mui/material";
import { Container } from "@mui/system";

export default function BaseUrlSelector() {
    return (isDevEnv && (
        <Container
            sx={{
                position: "fixed",
                right: 0,
                bottom: 0,
                padding: 0,
                margin: 0,
                width: "fit-content",
                zIndex: 1300,
            }}
        >
            <FormControl sx={{
                minWidth: 120,
                backgroundColor: "#FFFFFF",
                textAlign: "left",
                marginRight: 2,
                marginBottom: 0.75,
                borderRadius: 1,
            }}
            >
                <Select
                    labelId="base-url-select-label"
                    onChange={(e) => {
                        setUrl(e.target.value)
                    }} value={BASE_URL}>
                    {URLS.map((urlObj) => {
                        return (
                            <MenuItem key={urlObj.url} value={urlObj.url}>
                                {urlObj.name}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </Container>
    )
    );
}